/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Voice_Manager_Elevenlabs_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't load your ElevenLabs voices. {error}" |
*
* @param {Voice_Manager_Elevenlabs_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_error = /** @type {((inputs: Voice_Manager_Elevenlabs_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de charger vos voix ElevenLabs. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre ElevenLabs-Stimmen konnten nicht geladen werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare le tue voci ElevenLabs. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить голоса ElevenLabs. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron cargar tus voces de ElevenLabs. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法加载您的 ElevenLabs 语音。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ElevenLabs の音声を読み込めませんでした。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आपकी ElevenLabs आवाज़ें लोड नहीं हो सकीं। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível carregar as suas vozes da ElevenLabs. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Couldn't load your ElevenLabs voices. ${i?.error}`)
});